import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
var __default__ = {
  name: 'ChipsBar'
};
import { dragscroll as vDragscroll } from 'vue-dragscroll';
import { isNumber } from 'lodash-es';
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: {
    value: {
      default: ''
    },
    items: {
      default: function _default() {
        return [];
      }
    },
    centerActive: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    secondary: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    persistentBadge: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click:item", "input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var chipGroup = ref(null);
    var groups = computed(function () {
      return props.items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          badge: props.persistentBadge ? Boolean(item.badge) : props.value !== item.type && Boolean(item.badge)
        });
      });
    });
    onBeforeMount(function () {
      if (props.centerActive) {
        watch(function () {
          return props.value;
        }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _chipGroup$value, _chipGroup$value$quer;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return nextTick();
              case 2:
                _context.next = 4;
                return nextTick();
              case 4:
                _context.next = 6;
                return nextTick();
              case 6:
                (_chipGroup$value = chipGroup.value) === null || _chipGroup$value === void 0 ? void 0 : (_chipGroup$value$quer = _chipGroup$value.querySelector('.v-chip--active')) === null || _chipGroup$value$quer === void 0 ? void 0 : _chipGroup$value$quer.scrollIntoView({
                  behavior: 'smooth',
                  inline: 'center',
                  block: 'nearest'
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), {
          immediate: true
        });
      }
    });
    function handleClickItem(item) {
      emit('click:item', item);
      emit('input', item);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      chipGroup: chipGroup,
      groups: groups,
      handleClickItem: handleClickItem,
      vDragscroll: vDragscroll,
      isNumber: isNumber
    };
  }
}));